import React from "react";
import Blog_50_6 from "../component/Blog_50_6";
function Blog_50_6_container() {
  return <Blog_50_6 />;
}

export default Blog_50_6_container;
